import React, { useEffect, useState } from "react";
import "./DailyForecast.css";
import axios from "axios";
import WeatheForecastDay from "./WeatherForecastDay";

export default function DailyForecast(props) {
  const [forecast, setForecast] = useState(null);

  function handleResponse(response) {
    console.log(response);
    setForecast(response.data.daily);
  }

  useEffect(
    function () {
      let apiKey = "5723740d8d0f3d5046687fbab7668982";
      let longitude = props.coordinates.lon;
      let latitude = props.coordinates.lat;
      if (latitude && longitude) {
        let apiUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=${latitude}&lon=${longitude}&appid=${apiKey}&units=metric`;
        axios.get(apiUrl).then(handleResponse);
      }
    },
    [props.coordinates.lon, props.coordinates.lat]
  );

  console.log(props);

  if (forecast) {
    return (
      <div className="DailyForecast">
        <div className="container">
          <div className="row">
            {forecast.slice(1, 6).map(function (day, index) {
              return (
                <>
                  <WeatheForecastDay key={index} data={day} />{" "}
                </>
              );
            })}
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
}
